export default "__VITE_ASSET__C5ri3rTE__"